<template>
  <div ref="banner" v-show="couponList.length > 0">
    <swiper class="coupon" v-if="couponList.length > 0" :options="swiperOption">
      <div
        class="swiper-slide"
        v-for="(item, index) in couponList"
        :key="index"
      >
        <div class="price">
          <Currency class="currency"></Currency>
          <span class="discounted_price">
            {{ item.discounted_price | price }}元
          </span>
          <span class="full_reduction">
            满{{ item.full_reduction | price }}可用
          </span>
        </div>
        <div class="scope" v-if="item.dis_type == 1">
          {{
            item.scope_type == 1
              ? "全部课程"
              : item.scope_type == 2
              ? "指定课程分类"
              : "指定课程"
          }}可用
        </div>
        <div class="scope" v-else-if="item.dis_type == 4">
          {{
            item.scope_type == 1
              ? "全部约课"
              : item.scope_type == 2
              ? "指定讲师"
              : ""
          }}
        </div>
        <div class="scope" v-else-if="item.dis_type == 2">
          {{
            item.scope_type == 1
              ? "全部实物商品"
              : item.scope_type == 2
              ? "指定实物商品分类"
              : "指定实物商品"
          }}
        </div>
        <div class="scope" v-else-if="item.dis_type == 5">
          {{
            item.scope_type == 1
              ? "全部班级"
              : item.scope_type == 2
              ? "指定班级教学分类"
              : item.scope_type == 3
              ? "指定班级"
              : "指定班级年级"
          }}
        </div>
        <div class="scope" v-else-if="item.dis_type == 6">
          {{
            item.scope_type == 1
              ? "全部电子书"
              : item.scope_type == 2
              ? "指定电子书分类"
              : "指定电子书"
          }}
        </div>
        <div class="bottom">
          <div class="time">
            {{ getTime(item) }}
          </div>
          <a class="btn" @click="getCoupon(item.id)" v-if="item.is_draw == 0">
            立即领取
          </a>
          <a class="btn" @click="goToUsePage(item)" v-else>立即使用</a>
        </div>
      </div>
      <div
        class="swiper-button swiper-button-next"
        slot="button-prev"
        v-if="recommend.length > 1"
      ></div>
      <div
        class="swiper-button swiper-button-prev"
        slot="button-next"
        v-if="recommend.length > 1"
      ></div>
    </swiper>
  </div>
</template>
<script>
export default {
  name: "RecommendCoupon",
  props: {
    recommend: {
      type: Array,
    },
  },
  computed: {
    swiperOption() {
      return {
        autoplay: false,
        slidesPerView: "auto",
        spaceBetween: 16,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      };
    },
  },
  watch: {
    recommend(val) {
      this.couponList = val;
    },
  },
  data() {
    return {
      couponList: [],
    };
  },
  created() {
    this.couponList = this.recommend;
  },
  methods: {
    getTime(item) {
      let time = "有效期：";
      if (item.valid_type == 1) {
        time += item.valid_day + "天";
      } else {
        time +=
          new Date(item.valid_start * 1000).format("yyyy/MM/dd") +
          "-" +
          new Date(item.valid_end * 1000).format("yyyy/MM/dd");
      }
      return time;
    },
    async getCoupon(id) {
      let data = await this.$http.get("/api/app/userGetCoupon/" + id);
      this.couponList.filter(c => c.id == id)[0].is_draw =
        data.is_continue_get == 1 ? 0 : 1;
      this.$message({
        message: "领取成功",
        type: "success",
      });
    },
    goToUsePage(item) {
      this.$services.CouponService.goToUsePage(item);
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon {
  width: 1264px;
  padding: 0 32px;
  margin: 0 auto;
  box-sizing: border-box;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 120px;
    background: #f7f8fa;
    content: "";
    z-index: 10;
  }
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 120px;
    background: #f7f8fa;
    content: "";
    z-index: 10;
  }
  .swiper-slide {
    width: 360px; /*设为固定值*/
    height: 120px;
    padding: 0 18px;
    background: url(../../images/index/coupon-bg-active.png) no-repeat
      center/360px 120px;
    box-sizing: border-box;
    .price {
      padding-top: 10px;
    }

    .currency {
      font-weight: 500;
      font-family: PingFang SC, PingFang SC-Medium;
      background: linear-gradient(157deg, #ff7940 0%, #ffcf4f 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.1);
      font-size: 16px;
    }

    .discounted_price {
      display: inline-block;
      margin: 0 6px 0 3px;
      font-size: 32px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      background: linear-gradient(157deg, #ff7940 0%, #ffcf4f 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.1);
      line-height: 45px;
    }
    .full_reduction {
      display: inline-block;
      font-size: 14px;
      color: #666666;
      line-height: 20px;
      font-weight: 400;
    }
    .scope {
      margin-top: 5px;
      font-size: 13px;
      font-weight: 400;
      color: #666;
      line-height: 18px;
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .time {
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 17px;
      }
      .btn {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
        text-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.1);
      }
      a.btn {
        cursor: pointer;
      }
    }
  }
  .swiper-button-prev {
    top: 0;
    left: 0px;
    width: 28px;
    height: 120px;
    margin: 0;
    background: url(../../images/index/coupon-left-normal.png) no-repeat
      center/28px 120px;
    z-index: 100;
    &:hover {
      opacity: 1;
      background: url(../../images/index/coupon-left-hover.png) no-repeat
        center/28px 120px;
    }
    &:active {
      opacity: 1;
      background: url(../../images/index/coupon-left-press.png) no-repeat
        center/28px 120px;
    }
    &.swiper-button-disabled {
      opacity: 1;
      background: url(../../images/index/coupon-left-disabled.png) no-repeat
        center/28px 120px;
    }
  }
  .swiper-button-next {
    top: 0;
    right: 0px;
    width: 28px;
    height: 120px;
    margin: 0;
    background: url(../../images/index/coupon-right-normal.png) no-repeat
      center/28px 120px;
    z-index: 100;
    &:hover {
      opacity: 1;
      background: url(../../images/index/coupon-right-hover.png) no-repeat
        center/28px 120px;
    }
    &:active {
      opacity: 1;
      background: url(../../images/index/coupon-right-press.png) no-repeat
        center/28px 120px;
    }
    &.swiper-button-disabled {
      opacity: 1;
      background: url(../../images/index/coupon-right-disabled.png) no-repeat
        center/28px 120px;
    }
  }
}
</style>
